<template>
    <div></div>
</template>

<script>
    export default {
        props: {
            api: { type: Object, required: true },
            map: { type: Object, required: true },
            marker: { type: Object, required: true },
        },

        mounted() {
            new this.api.maps.Marker({
                position: this.marker.position,
                marker: this.marker,
                map: this.map,
            })
        },
    }
</script>
